import React, { useMemo, useState } from 'react';
import { AgentTaskWrapperStyles, StyledAgentDetail } from './AgentDetail.styles';
import agent2 from '../../../assets/images/agent2.png';
import Button from '../../molecules/Button';
import { FaPlus } from 'react-icons/fa6';
import Table from '../../molecules/Table';
import TableLayout from '../../molecules/TableLayout';
import CircleGraph from '../CircleGraph';
import downloadIcon from '../../../assets/images/download_icon.svg';
import ModalContainer from '../../molecules/ModalContainer';
import { useNavigate, useParams } from 'react-router-dom';
import leadService from '../../../services/leadService';
import usePersistedSearchQuery from '../../../hooks/usePersistedSearchQuery';
import { formatDateWithSuffix } from '../../../helpers/common';
import { IoReload } from 'react-icons/io5';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

const AgentDetail = () => {
  const [searchQuery, setSearchQuery] = usePersistedSearchQuery({
    page: 1,
    itemsPerPage: 10,
    merchant_id: '',
    terminal_id: '',
    transaction_type: '',
    card_type: '',
    start_date: '',
    end_date: '',
    search: '',
    start_time: '',
    end_time: '',
  });
  const { refetch, fetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
    fetch: v.fetch,
  }));
  const ActionBtn = data => {
    switch (data.status) {
      case 'SUCCEEDED':
        return (
          <a className="downloadIconWrapper" href={data?.output_csv} download>
            <img src={downloadIcon} alt="download_icon" />
          </a>
        );
      case 'FAILED':
        return (
          <div className="graph-wrap">
            <CircleGraph size={'30px'} value={0} />
          </div>
        );
      case 'SUBMITTED':
        return (
          <div className="graph-wrap">
            <CircleGraph size={'30px'} value={10} />
          </div>
        );
      case 'RUNNING':
        return (
          <div className="graph-wrap">
            {/* Discuss */}
            <CircleGraph size={'30px'} value={20} />
          </div>
        );

      default:
        break;
    }
  };
  const StatusBadge = data => {
    switch (data.status) {
      case 'SUCCEEDED':
        return <div className="badge success">{data?.status}</div>;
      case 'FAILED':
        return <div className="badge danger">{data?.status}</div>;
      case 'SUBMITTED':
        return <div className="badge pending">{data?.status}</div>;
      case 'RUNNING':
        return <div className="badge pending">{data?.status}</div>;
      default:
        break;
    }
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const { agent_loading, agent_data } = leadService.GetAgent(searchQuery, id, fetch);
  const columnNamess = [`Date`, `Task Name `, `Leads`, `Credits used`, `STATUS`, `Action`];
  const { product_rows, totalCount } = useMemo(() => {
    return {
      product_rows: agent_data?.data?.items?.map(data => [
        formatDateWithSuffix(data?.created_at) || '------------',
        data?.task_name || '------------',
        data?.numOfLeads || '------------',
        data?.numOfLeads || '------------',
        StatusBadge(data) || '------------',
        ActionBtn(data) || '------------',
      ]),
      totalCount: agent_data?.data?.totalItems,
    };
  }, [agent_data?.data?.items]);

  return (
    <StyledAgentDetail>
      <div className="detail-header">
        <div className="image-text">
          <div className="image-wrapper">
            <img src={agent_data?.agentDetail?.agentImage || agent2} alt="" width={52} height={68} />
          </div>
          <div className="text-wrap">
            <strong className="name">{agent_data?.agentDetail?.fullName}</strong>
            <p>{agent_data?.agentDetail?.title}</p>
          </div>
        </div>
        <div className="two-wrap">
          <div className="btn-wrap-two" onClick={() => navigate('create-task')}>
            <Button variant="primary">
              <FaPlus /> Add new task
            </Button>
          </div>
        </div>
      </div>

      <AgentTaskWrapperStyles>
        <div className="table-header-wrapper">
          <strong className="table-title">All Tasks</strong>
          <button onClick={() => refetch()}>
            <IoReload size={24} />
          </button>
        </div>
        <TableLayout
          onChangeFilters={filters => {
            setSearchQuery(_ => ({
              ..._,
              // searchText: filters,
              ...filters,
            }));
          }}
          currentPage={searchQuery?.page}
          pageSize={searchQuery?.itemsPerPage}
          totalCount={totalCount}>
          <Table rowsData={product_rows} columnNames={columnNamess} noPadding loading={agent_loading} />
        </TableLayout>
      </AgentTaskWrapperStyles>
    </StyledAgentDetail>
  );
};

export default AgentDetail;
